// Port of api/fuel/app/classes/insights/collection/rankings.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'rankings',
    detail: false,
    insight: ['ranking.band'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var own = []
        var bands = []
        var stats = {
            top100: 0,
            top1000: 0,
            ranked: 0,
            highest: 0,
            lowest: 0,
            longest: [0, 0],
            levels: 0,
            levelmost: [0, 0],
            levelnone: [0, 0]
        }

        var currentBand = (filter['ranking.band'] !== undefined) ? filter['ranking.band'] : 1

        var collectionRows = Util.queryFast('\
            SELECT \
                g.game_id AS g, \
                g.game_rank AS r \
            FROM \
                collection c, \
                game g \
            WHERE \
                c.user_id IN (' + Util.in(userIndex) + ') \
                AND \
                c.game_id = g.game_id \
                AND \
                g.game_type = 1 \
                AND \
                c.collection_own = 1 \
            GROUP BY \
                g.game_id \
            ORDER BY \
                g.game_rank \
        ')
        var collectionIndex = Util.keyed_array(collectionRows, 'g')

        var streakCount = 0
        var streakLast = null

        var streakStart = 0
        var streakEnd = 0
        var streakLongest = 0

        var rankedTotal = 0

        if (collectionRows.length) {

            var maxRank = 0
            var minRank = 0
            var maxRankItem = null
            var minRankItem = null

            for (var ci = 0; ci < collectionRows.length; ci++) {
                var item = collectionRows[ci]

                if (item.r > 0) {

                    rankedTotal++

                    if (streakLast === null || (streakLast !== null && item.r - streakLast === 1)) {

                        streakLast = item.r
                        streakCount++

                    } else {

                        if (streakCount > streakLongest) {
                            streakLongest = streakCount
                            streakStart = streakLast - (streakCount - 1)
                            streakEnd = streakLast
                        }

                        streakCount = 1
                        streakLast = item.r

                    }

                    if (!minRank) {
                        minRank = item.r
                        minRankItem = item
                    }

                    if (!maxRank || item.r > maxRank) {
                        maxRank = item.r
                        maxRankItem = item
                    }

                }
            }

            // check final streak
            if (streakCount > streakLongest) {
                streakLongest = streakCount
                streakStart = streakLast - (streakCount - 1)
                streakEnd = streakLast
            }

            var minBandRank = (currentBand * 100) + 1
            var maxBandRank = (currentBand + 1) * 100

            for (var bi = 0; bi < Math.ceil(maxRank / 100); bi++) {
                bands.push(0)
            }

            for (var ci2 = 0; ci2 < collectionRows.length; ci2++) {
                var item2 = collectionRows[ci2]

                if (item2.r > 0) {
                    bands[Math.floor((item2.r - 1) / 100)]++
                }
            }

            // game! table reference -> just game (no Booster in offline mode)
            var gameIndex = Util.queryFast('\
                SELECT \
                    g.game_id AS g, \
                    g.game_rank AS r \
                FROM \
                    game g \
                WHERE \
                    g.game_rank >= ' + minBandRank + ' \
                    AND \
                    g.game_rank <= ' + maxBandRank + ' \
                ORDER BY \
                    g.game_rank \
                LIMIT \
                    0, 100 \
            ', null, 'r')

            for (var oi = minBandRank; oi <= maxBandRank; oi++) {

                if (gameIndex[oi] !== undefined) {

                    this._references.games.push(gameIndex[oi].g)

                    own.push({
                        id: parseInt(gameIndex[oi].g, 10),
                        rank: oi,
                        own: collectionIndex[gameIndex[oi].g] !== undefined
                    })

                } else {

                    own.push({
                        id: 0,
                        rank: oi,
                        own: false
                    })

                }

            }

            var bandMostCount = 0
            var bandMostLevel = 0
            var bandNoneLevel = null

            for (var bdi = 0; bdi < bands.length; bdi++) {
                var band = bands[bdi]

                if (band) {
                    stats.levels++
                }

                if (bandMostCount < band) {
                    bandMostLevel = bdi
                    bandMostCount = band
                }

                if (!band && bandNoneLevel === null) {
                    bandNoneLevel = bdi
                }
            }

            stats.longest[0] = streakStart
            stats.longest[1] = streakEnd

            stats.levelmost[0] = (bandMostLevel * 100) + 1
            stats.levelmost[1] = (bandMostLevel + 1) * 100

            if (bandNoneLevel !== null) {
                stats.levelnone[0] = (bandNoneLevel * 100) + 1
                stats.levelnone[1] = (bandNoneLevel + 1) * 100
            }

            stats.highest = minRank
            stats.lowest = maxRank

            stats.top100 = bands[0] || 0
            stats.top1000 = bands.slice(0, 10).reduce(function(a, b) { return a + b }, 0)
            stats.ranked = (100 / collectionRows.length) * rankedTotal
        }

        return {
            rankings: {
                own: own,
                stats: stats,
                bands: bands
            }
        }

    }
})
